/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindAllQueryResponse, OrganizationsControllerFindAllQueryParams, OrganizationsControllerFindAll401, OrganizationsControllerFindAll403 } from "../../models/organizationsController/OrganizationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { organizationsControllerFindAll } from "../../clients/organizationsService/organizationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const organizationsControllerFindAllQueryKey = (params: OrganizationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/organizations'
}, ...(params ? [params] : [])] as const;
export type OrganizationsControllerFindAllQueryKey = ReturnType<typeof organizationsControllerFindAllQueryKey>;
export function organizationsControllerFindAllQueryOptions(params?: OrganizationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = organizationsControllerFindAllQueryKey(params);
  return queryOptions<OrganizationsControllerFindAllQueryResponse, ResponseErrorConfig<OrganizationsControllerFindAll401 | OrganizationsControllerFindAll403>, OrganizationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return organizationsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all organizations for the current user
 * {@link /api/v1/organizations}
 */
export function useOrganizationsControllerFindAll<TData = OrganizationsControllerFindAllQueryResponse, TQueryData = OrganizationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = OrganizationsControllerFindAllQueryKey>(params?: OrganizationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<OrganizationsControllerFindAllQueryResponse, ResponseErrorConfig<OrganizationsControllerFindAll401 | OrganizationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? organizationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...organizationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OrganizationsControllerFindAll401 | OrganizationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}